import tipoDiligenciaRoutes from "./parametrizacion/tipoDiligenciaRoutes";
import dependenciaRoutes from "./parametrizacion/dependenciaRoutes";
import usuarioRoutes from "./parametrizacion/usuarioRoutes";
import usuarioBloqueadoRoutes from "./parametrizacion/usuarioBloqueadoRoutes";
import personaFisicaRoutes from "./parametrizacion/personaFisicaRoutes";
import modelosRoutes from "./parametrizacion/modelosRoutes";
import tipoEfectoDepositoRoutes from "./parametrizacion/tipoEfectoDepositoRoutes";
import sitioRoutes from "./parametrizacion/sitioRoutes";

import LayoutParametrizacion from "@/pages/parametros/LayoutParametrizacion";
import isUserRolGuard from "@/guards/isUserRolGuard";

export default {
  component: LayoutParametrizacion,
  redirect: "/parametros/list",
  name: "parametros",
  children: [
    {
      //'parametros/listado'
      path: "list",
      name: "parametros-list",
      component: () => import("@/pages/ParametrizacionPage.vue"),
      beforeEnter: isUserRolGuard,
    },

    {
      //'parametros/genero'
      path: "genero",
      name: "genero",
      meta: { showBackButton: true },
      component: () => import("@/pages/parametros/Genero/genero.vue"),
      beforeEnter: isUserRolGuard,
    },
    {
      //'parametros/estadocivil'
      path: "estadocivil",
      name: "estadocivil",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/EstadoCivil/estadoCivil.vue"),
    },
    {
      //'parametros/deposito-dependencia'
      path: "deposito-dependencia",
      name: "deposito-dependencia",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/DepositoDependencia/depositoDependencia.vue"),
    },
    {
      //'parametros/provincias'
      path: "provincias",
      name: "provincias",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Provincia/provincia.vue"),
    },
    {
      path: "tipo-moneda",
      name: "tipo-moneda",
      beforeEnter: isUserRolGuard,
      meta: { showBackButton: false },
      component: () => import("@/pages/parametros/TipoMoneda/tipoMoneda.vue"),
    },
    //v2
    ...sitioRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
    ...dependenciaRoutes.map((route) => ({ ...route })),
    {
      //'parametros/articulos'
      path: "articulos",
      name: "articulos",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Articulos/articulos.vue"),
    },
    {
      //'parametros/juzgados'
      path: "juzgados",
      name: "juzgados",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Juzgado/juzgado.vue"),
    },
    {
      //'parametros/departamentales'
      path: "departamentales",
      name: "departamentales",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Departamental/departamental.vue"),
    },
    {
      //'parametros/paises'
      path: "paises",
      name: "paises",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Pais/pais.vue"),
    },
    ...personaFisicaRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
    {
      path: "modus-operandi",
      name: "modus-operandi",
      beforeEnter: isUserRolGuard,
      meta: { showBackButton: false },
      component: () => import("@/pages/parametros/ModusOperandi/modusOperandi.vue"),
    },
    {
      //'parametros/marcas'
      path: "marcas",
      name: "marcas",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Marca/marca.vue"),
    },
    {
      //'parametros/categorias'
      path: "categorias",
      name: "categorias",
      meta: { showBackButton: false },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Categoria/categoria.vue"),
    },
    ...tipoEfectoDepositoRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
    {
      //'parametros/caratula'
      path: "caratula",
      name: "caratula",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/Caratula/Caratula.vue"),
    },
    {
      //'parametros/personal-fiscal'
      path: "personal-fiscal",
      name: "personal-fiscal",
      meta: { showBackButton: true },
      component: () => import("@/pages/parametros/PersonalFiscal/personalFiscal.vue"),
      beforeEnter: isUserRolGuard,
    },
    {
      //'parametros/sub-categorias'
      path: "sub-categorias",
      name: "sub-categorias",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () => import("@/pages/parametros/SubCategoria/subCategoria.vue"),
    },
    ...modelosRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
    ...tipoDiligenciaRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
    {
      //'parametros/categorias-tipo-archivo'
      path: "categorias-tipo-archivo",
      name: "categorias-tipo-archivo",
      meta: { showBackButton: true },
      beforeEnter: isUserRolGuard,
      component: () =>
        import("@/pages/parametros/CategoriaTipoArchivoPDF/categoria-tipo-archivopdf.vue"),
    },
    {
      //'parametros/gestor-archivos'
      path: "gestor-archivos",
      name: "gestor-archivos",
      beforeEnter: isUserRolGuard,
      meta: { showBackButton: true },
      component: () => import("@/pages/parametros/Biblioteca/gestor-de-archivos.vue"),
    },

    ...usuarioRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
    ...usuarioBloqueadoRoutes.map((route) => ({ ...route, meta: { showBackButton: true } })),
  ],
};
